/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { SessionService } from '../../services/session2.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { ErrorService } from '../../services/error.service';
import { AccountService } from '../../services/account.service';
import { EloquaService } from '../../services/eloqua.service';
import { HubspotService } from '../../services/hubspot.service';
import { MarketoService } from '../../services/marketo.service';
import { PardotService } from '../../services/pardot.service';
import { EnrichService } from '../../services/enrich.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { DriftService } from '../../services/drift.service';
import { Constants, StaticDate } from '../../global/constants';

@Component({
  selector: 'app-enrich',
  templateUrl: './enrich.component.html'
})
export class EnrichComponent implements OnInit {

  loadingPage: boolean = true;
  session: any;

  syncs: any = {};

  syncType: any = {
    phone: 1,
    title: 1
  };

  fields: any[] = [];
  currentField: any = {
    phone: '',
    title: ''
  };

  integrations: any = {
    marketo: false,
    eloqua: false,
    hubspot: false,
    acton: false,
    pardot: false
  };

  integrationCount: number = 0;
  singleIntegration: string = '';

  constructor(private sessionService: SessionService,
    private cacheService: CacheService,
    private errorService: ErrorService,
    private accountService: AccountService,
    private enrichService: EnrichService,
    private globalMessageService: GlobalMessageService,
    private constants: Constants,
    private driftService: DriftService,
    private eloquaService: EloquaService,
    private hubspotService: HubspotService,
    private marketoService: MarketoService,
    private pardotService: PardotService) { }

  ngOnInit() {
    this.session = this.cacheService.get('session');
    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  toggleSync(fieldType: string) {
    this.syncs[fieldType].enabled = !this.syncs[fieldType].enabled;
    var update = {};
    update[fieldType] = this.syncs[fieldType];
    this.saveSync(update);
    if (this.syncs[fieldType].enabled) {
      this.driftService.track('enabled-enrich', { type: fieldType });
    }
    else {
      this.driftService.track('disabled-enrich', { type: fieldType });
    }
  }

  changeType(fieldType: string, type: number) {
    var update = {};
    update[fieldType] = this.syncs[fieldType];

    if (type == 2) {
      update[fieldType].override = true;
      this.currentField[fieldType] = '';
    }
    else {
      update[fieldType].override = false;
      if (type == 1) {
        update[fieldType].secondary_field = null;
        this.currentField[fieldType] = '';
      }
    }
    this.saveSync(update);
    this.driftService.track('edited-enrich', { type: fieldType });
  }

  changeField(field, fieldType) {
    this.currentField[fieldType] = field.value;
    var update = {};
    update[fieldType] = this.syncs[fieldType];

    var findField = this.fields.find((f) => {
      return f.value == field.value;
    });

    update[fieldType].secondary_field = {
      id: field.value,
      name: findField.name,
      description: field.label
    };

    this.saveSync(update);
    this.driftService.track('edited-enrich', { type: fieldType });
  }

  private initView() {
    this.loadingPage = true;
    Observable.forkJoin(
      this.enrichService.getSyncs()
    ).subscribe(
      (result: any) => {
        // for now we only allow a single sync/integration. In the future we'll need to use the whole array for editing
        this.syncs = result[0].length > 0 ? result[0][0] : {};
        this.setupSyncs();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'enrich.component', 'initView');
      }
      )
  }

  private setupSyncs() {
    if (this.syncs.phone) {
      this.syncType.phone = 1;
      if (this.syncs.phone.override) {
        this.syncType.phone = 2;
      }
      else if (this.syncs.phone.secondary_field) {
        this.syncType.phone = 3;
      }
    }

    if (this.syncs.title) {
      this.syncType.title = 1;
      if (this.syncs.title.override) {
        this.syncType.title = 2;
      }
      else if (this.syncs.title.secondary_field) {
        this.syncType.title = 3;
      }
    }

    if (this.syncs.partner) {
      this.loadFields();
    }
    else {
      // first time setup - check for integrations and create a new set of enrich syncs
      this.loadIntegrations();
    }
  }

  /**
   * Only called when there hasn't been a sync set up yet
   */
  private loadIntegrations() {
    this.integrationCount = 0;
    this.accountService.getIntegrations().subscribe(
      (result: any) => {
        if (result.acton) {
          this.integrations.acton = true;
          this.integrationCount++;
          this.singleIntegration = 'acton';
        }

        if (result.hubspot) {
          this.integrations.hubspot = true;
          this.integrationCount++;
          this.singleIntegration = 'hubspot';
        }
        if (result.eloqua) {
          this.integrations.eloqua = true;
          this.integrationCount++;
          this.singleIntegration = 'eloqua';
        }
        if (result.pardot) {
          this.integrations.pardot = true;
          this.integrationCount++;
          this.singleIntegration = 'pardot';
        }
        if (result.marketo) {
          this.integrations.marketo = true;
          this.integrationCount++;
          this.singleIntegration = 'marketo';
        }
        if (this.singleIntegration) {
          this.initSyncs();
        }
        else {
          this.loadingPage = false;
        }
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'enrich.component', 'loadIntegrations');
      });
  }

  private initSyncs() {
    this.enrichService.initSyncs(this.singleIntegration).subscribe(
      (result: any) => {
        // even though we return the new sync here, run through the normal load process
        this.initView();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'enrich.component', 'loadIntegrations');
      }
    )
  }

  private loadFields() {
    if (this.syncs.partner.toLowerCase() == 'eloqua') {
      this.eloquaService.getFields().subscribe(
        (result: any) => {
          this.setupFields(result);
          this.loadingPage = false;
        },
        error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'enrich.component', 'loadFields');
        }
      );
    }
    else if (this.syncs.partner.toLowerCase() == 'hubspot') {
      this.hubspotService.getFields().subscribe(
        (result: any) => {
          this.setupFields(result);
          this.loadingPage = false;
        },
        error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'enrich.component', 'loadFields');
        }
      );
    }
    else if (this.syncs.partner.toLowerCase() == 'marketo') {
      this.marketoService.getFields().subscribe(
        (result: any) => {
          this.setupFields(result);
          this.loadingPage = false;
        },
        error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'enrich.component', 'loadFields');
        }
      );
    }
    else if (this.syncs.partner.toLowerCase() == 'pardot') {
      this.pardotService.getFields().subscribe(
        (result: any) => {
          this.setupFields(result);
          this.loadingPage = false;
        },
        error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'enrich.component', 'loadFields');
        }
      );
    }
  }

  private setupFields(fields: any[]) {
    this.fields = [];
    fields.forEach((f) => {
      this.fields.push({
        label: f.description,
        value: f.id.toString(),
        name: f.name
      });
    });
    if (this.syncs.phone.secondary_field) {
      this.currentField.phone = this.syncs.phone.secondary_field.id;
    }
    if (this.syncs.title.secondary_field) {
      this.currentField.title = this.syncs.title.secondary_field.id;
    }
  }

  private saveSync(update) {
    this.enrichService.savePartial(this.syncs._id, update).subscribe(
      (result: any) => {
        this.globalMessageService.message('Enrich settings updated');
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'enrich.component', 'saveSync');
      }
    )
  }

  private saveSession() {
    this.session.enrich_filters.last_changed = new Date();
    this.sessionService.saveSession(this.session).subscribe(
      (result: any) => {
        // Nothing
      },
      err => {
        this.errorService.log(err, 'enrich.component', 'saveSession');
      }
    )
  }
}



// WEBPACK FOOTER //
// ./client/app/config/enrich/enrich.component.ts